
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.959 3.184c-1.475-.755-3.19.112-3.716 1.683l-.286.854a17 17 0 0110.147 10.135l.854-.287c1.57-.528 2.435-2.244 1.678-3.718a20.002 20.002 0 00-8.677-8.667z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.207 16.494a15.001 15.001 0 00-8.885-8.875l-.653 1.949c-.107.319.128.65.454.734a3 3 0 11-1.9 5.676c-.31-.13-.698-.006-.805.313l-.935 2.79a1 1 0 001.267 1.265l11.457-3.852zM11.33 15.33a1 1 0 101.415-1.414 1 1 0 00-1.415 1.414z"}})])
          )
        }
      }
    